<table style="border-collapse: collapse">
  <tr *ngFor="let user of users">
    <td>
      {{ user.name }}
    </td>
    <td>
      {{ user.email }}
    </td>
    <td>
      <small *ngIf="user.email === currentUserEmail">(현재 로그인됨)</small>
    </td>
  </tr>
  <tr>
    <td>비밀번호</td>
    <td>&123456</td>
  </tr>
</table>
